import { Component, OnDestroy, OnInit } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { MatDialog } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ActivatedRoute, Router } from '@angular/router'
import * as moment from 'moment'
import { Subscription } from 'rxjs'
import { NotificationService } from '../../../../notification/shared/notification.service'
import { CommandeSettingsCoeff, CommandeSettingsDeliveries } from '../../../settings/commande-param/commande-param-settings/shared/commande-param-settings'
import { CommandeParamSettingsService } from '../../../settings/commande-param/commande-param-settings/shared/commande-param-settings.service'
import { Client } from '../../../shared/client/client'
import { ClientService } from '../../../shared/client/client.service'
import { CommandeDetails, LigneCommande, ListLigneCommande } from '../../shared/commande'
import { CommandeEditDialogComponent } from '../../shared/commande-edit-dialog/commande-edit-dialog.component'
import { CommandeEditReturnDialogComponent } from '../../shared/commande-edit-return-dialog/commande-edit-return-dialog.component'
import { CommandeService } from '../../shared/commande.service'

@Component({
  selector: 'app-commande-edit',
  templateUrl: './commande-edit.component.html',
  styleUrls: ['./commande-edit.component.scss']
})
export class CommandeEditComponent implements OnInit, OnDestroy {

  commandeId: string
  currentClient: Client
  commandeDetails: CommandeDetails
  loading: boolean = false
  public isQuantitiesAt0: boolean = false
  public isSubmittable: boolean = false
  article: LigneCommande
  coefficient: CommandeSettingsCoeff
  public curDay: string
  public curDayNumber: number = 1
  public CommandeParamSettingsDeliveries: CommandeSettingsDeliveries[]
  public curDayMultiplier: CommandeSettingsDeliveries[] = []
  public defaultQuantity = null
  public enabledConditionnement: boolean = false
  saving: boolean = false

  group: UntypedFormGroup

  subClient: Subscription

  canEditSend: boolean = false
  commandeAmadeus

  constructor(
    private clientService: ClientService,
    private commandeService: CommandeService,
    private commandeSettingsService: CommandeParamSettingsService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private router: Router,
    private notificationService: NotificationService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.group = new UntypedFormGroup({
      'inputdate': new UntypedFormControl({ value: '', disabled: false }, [
      ])
    })

    this.loading = true

    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.currentClient = client
      this.route.queryParams.subscribe(params => {
        this.commandeId = params.id
        this.canEditSend = params.canEditSend

        if (this.commandeId != null) {
          this.getCommandeDetails(this.commandeId)
          this.getClientCoefficient()
          this.getClientConditionnement()
        }
      })
    })
  }

  ngOnDestroy() {
    this.snackBar.dismiss()
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  getCommandeDetails(commandeId: string) {
    this.loading = true
    this.commandeService.getCommandeDetails(commandeId).subscribe(async data => {
      this.commandeDetails = data

      //Retourne à la liste des commandes si pas le bon statut
      if (!this.canEditSend &&
        this.commandeDetails.statut.code != 'AT12H' &&
        this.commandeDetails.statut.code != 'AS12H' &&
        this.commandeDetails.statut.code != 'AT' &&
        this.commandeDetails.statut.code != 'AS'
      ) {
        this.router.navigate(['/escli/linge-hebergement/list']).then(() => {
          this.notificationService.notif("Cette commande n'est plus modifiable", "error")
        })
      }

      if (this.canEditSend) {
        this.commandeService.getCommandeAmadeus(commandeId).subscribe(data => {
          this.commandeAmadeus = data
        })
      }

      // Vérifie si une ligne a qte_stock à 0 si oui force la quantite à null
      this.commandeDetails.lod_ligne_commandes.forEach(element => {
        if (element.qte_stock == 0) {
          element.quantite = 0
        }
      })


      // Vérifie si une line à été supprimé et affichage message
      let list = this.commandeDetails.lod_ligne_commandes.filter(item => item['delete_line'])
      let listString = []
      list.forEach(element => {
        listString.push(element.article.designation)
      })
      if (listString.length > 0) {
        this.loading = true
        if (listString.length == 1) {
          this.notificationService.notif("L'article " + listString[0] + " n'est plus dans votre contrat, il est retiré de la commande", "warn", 5000)
        } else {
          this.notificationService.notif("Les articles " + listString + " ne sont plus dans votre contrat, ils sont retirés de la commande", "warn", 5000)
        }
        const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))
        await sleep(5000)
        location.reload()
      } else {
        this.curDay = moment(this.commandeDetails.date_livraison).locale('fr').format('dddd')
        this.curDayNumber = moment(this.commandeDetails.date_livraison).day()
        this.getClientDeliveries()
        this.loading = false
        this.checkSubmittable()
      }
    }
    )
  }

  getClientDeliveries() {
    this.commandeSettingsService.getCommandDeliveries(this.currentClient.id).subscribe(
      (data) => {
        this.CommandeParamSettingsDeliveries = data
        this.curDayMultiplier = this.CommandeParamSettingsDeliveries.filter(coef => coef.jrs_relivraison_lp === this.curDayNumber)
        if (!('multiple_mab_jour' in this.curDayMultiplier[0]) || this.curDayMultiplier[0].multiple_mab_jour === 0) {
          this.curDayMultiplier[0].multiple_mab_jour = 1
        }
      }
    )
  }

  getClientCoefficient() {
    this.commandeSettingsService.getCommandMaxOrderRatio(this.currentClient.id).subscribe(
      (data) => {
        this.coefficient = data
      })
  }

  updateValue(ligneCommande: ListLigneCommande, event: any) {
    let maxValue = this.getQuantityMax(ligneCommande)

    if (this.canEditSend) {
      let quantiteAmadeus = this.getQuantityTransmise(ligneCommande)

      if (+event.target.value < quantiteAmadeus) {
        event.target.value = quantiteAmadeus
        this.notificationService.notif("Quantité saisie inférieure à la quantité déjà transmise", 'warn')
      }
    }

    if (+event.target.value > maxValue) {
      event.target.value = maxValue
      this.notificationService.notif("Quantité saisie supérieure à la quantité max", 'warn')
    }
    else if (+event.target.value < 0) {
      event.target.value = 0
    }

    if (event.target.value != "") {
      this.commandeDetails.lod_ligne_commandes.find(x => x.id == ligneCommande.id).quantite = event.target.value
    } else {
      this.commandeDetails.lod_ligne_commandes.find(x => x.id == ligneCommande.id).quantite = null
    }

    if (this.isQuantitiesAt0) {
      this.isQuantitiesAt0 = false
      this.commandeDetails.lod_ligne_commandes.forEach(ligne => {
        if (ligne.id != ligneCommande.id) {
          if (this.canEditSend) {
            ligne.quantite = this.getQuantityTransmise(ligneCommande)
          } else {
            ligne.quantite = null
          }
        }
      })
    }
    this.checkSubmittable()
  }

  updateQuantities($event: MouseEvent) {
    this.loading = true
    if (this.isQuantitiesAt0) {
      this.isQuantitiesAt0 = false
      this.commandeDetails.lod_ligne_commandes.forEach(ligne => {
        ligne.quantite = null
      })
    } else {
      this.isQuantitiesAt0 = true
      this.commandeDetails.lod_ligne_commandes.forEach(ligne => {
        ligne.quantite = 0
      })
    }
    this.checkSubmittable()
    setTimeout(() => {
      this.loading = false
    }, 500)
  }

  checkSubmittable() {
    if (this.commandeDetails.lod_ligne_commandes.every(ligne => ligne.quantite != null)) {
      this.isSubmittable = true
    } else {
      this.isSubmittable = false
    }
    if (this.commandeDetails.lod_ligne_commandes.every(ligne => ligne.quantite == 0)) {
      this.isQuantitiesAt0 = true
    }
  }

  onSubmit() {
    if (!this.isSubmittable) {
      this.notificationService.notif("Votre commande comporte des quantités vides, si vous ne souhaitez pas commander l'article, merci de renseigner 0, sinon indiquez la quantité à commander.", 'error', 10000)
      return
    }

    this.saving = true
    this.commandeService.getCommandeDetails(this.commandeId).subscribe(data => {
      if (data.statut.code !== "T" && data.statut.code !== "DD" && data.statut.code !== "T0") {
        this.commandeDetails.lod_ligne_commandes.forEach(ligne => {
          let article = {
            article: ligne.article.id,
            quantite: ligne.quantite,
          }
          this.commandeService.updateCommandeDetails(this.commandeId, this.currentClient.id, ligne.id, article).subscribe()
        })
        this.commandeService.updateStatus(this.commandeId, this.currentClient).subscribe(status => {
          this.router.navigate(['/escli/linge-hebergement/list']).then(() => {
            this.notificationService.notif("Commande mise à jour", "notif");
          })
        })
      } else {
        if (data.statut.code == "DD") {
          this.commandeDetails = data
          this.notificationService.notif("Le délai de commande est dépassé, vous avez jusqu'à 12h30 pour cliquer sur 'Enregistrer & Transmettre'", "error")
        } else {
          this.router.navigate(['/escli/linge-hebergement/list']).then(() => {
            this.notificationService.notif("Commande déjà transmise", "error")
          })
        }
      }
      this.saving = false
    })
  }

  refuse() {
    this.saving = true
    this.commandeService.getCommandeDetails(this.commandeId).subscribe(data => {
      if (data.statut.code == "DD") {
        this.commandeDetails = data
        let dialogRef = this.dialog.open(CommandeEditReturnDialogComponent)
        dialogRef.afterClosed().subscribe(value => {
          this.saving = false
        })
      } else {
        this.saving = false
        this.router.navigate(['/escli/linge-hebergement/list'])
      }

    })
  }

  getQuantityMax(article: ListLigneCommande) {
    if (article.qte_stock && article.qte_stock > 0) {
      return Math.ceil(+(this.curDayMultiplier[0]?.multiple_mab_jour * article.qte_mab * this.coefficient?.coeff_max_commande))
    } else {
      return 0
    }
  }

  getQuantityTransmise(article: ListLigneCommande) {
    if (this.commandeAmadeus) {
      let articleAmadeus = this.commandeAmadeus.commande_lignes.find(x => x.code_article === article.article.code_article)
      return articleAmadeus?.quantite
    } else {
      return null;
    }
  }

  openDialog(): void {
    if (!this.isSubmittable) {
      this.notificationService.notif("Votre commande comporte des quantités vides, si vous ne souhaitez pas commander l'article, merci de renseigner 0, sinon indiquez la quantité à commander.", 'error', 10000)
      return
    }

    this.saving = true
    let dialogRef = this.dialog.open(CommandeEditDialogComponent, {
      data: { lod_ligne_commandes: this.commandeDetails.lod_ligne_commandes, commandeId: this.commandeId, currentClient: this.currentClient, canEditSend: this.canEditSend }
    })
    dialogRef.afterClosed().subscribe(value => {
      this.saving = false
    })
  }

  getClientConditionnement() {
    this.commandeSettingsService.getCommandConditionnement(this.currentClient.id).subscribe(data => {
      this.enabledConditionnement = data?.enabled_conditionnement ?? false
      this.loading = false
    })
  }
}
